module.exports = __webpack_public_path__ + "static/media/fedpa-parking-selected.40080042.svg";